module.exports = __webpack_public_path__ + "img/机智.cf3685ab.png";